var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystoreDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 31.8,
    y1: 183.29,
    x2: 15.02,
    y2: 166.51,
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43.83,
    y1: 172,
    x2: 19.64,
    y2: 172,
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 34.83,
    y1: 169.7,
    x2: 12.07,
    y2: 146.95,
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17.3,
    y1: 191.82,
    x2: 27.46,
    y2: 181.66,
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fr_get") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h155v60H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 135,
    height: 40,
    rx: 5,
    ry: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 10.8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H15a4.2 4.2 0 0 1-4.2-4.2V15a4.2 4.2 0 0 1 4.2-4.2h125m0-.8H15a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V15a5 5 0 0 0-5-5z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.14 31.75A4.25 4.25 0 1 0 82.41 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-9.31-6.83A4.25 4.25 0 1 0 73.09 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83A2.58 2.58 0 1 1 71.22 36a2.46 2.46 0 0 1-2.4 2.58zm-11.09-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.42 4.42 0 0 1-3.33 1.32 4.8 4.8 0 0 1 0-9.6A4.6 4.6 0 0 1 61 30.14l1.27-1.27A6.29 6.29 0 0 0 57.74 27a6.61 6.61 0 1 0 0 13.21 6 6 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.22 5.87 5.87 0 0 0-.1-1.13zm45.31 1.4a4 4 0 0 0-3.64-2.71 4 4 0 0 0-4 4.25 4.16 4.16 0 0 0 4.22 4.25 4.23 4.23 0 0 0 3.54-1.88l-1.45-1a2.43 2.43 0 0 1-2.09 1.18 2.16 2.16 0 0 1-2.06-1.29l5.69-2.35zm-5.8 1.42a2.33 2.33 0 0 1 2.22-2.48 1.65 1.65 0 0 1 1.58.9zM92.63 40h1.87V27.5h-1.87zm-3.06-7.3h-.07a3 3 0 0 0-2.24-1 4.26 4.26 0 0 0 0 8.51 2.9 2.9 0 0 0 2.24-1h.06v.61c0 1.63-.87 2.5-2.27 2.5a2.35 2.35 0 0 1-2.14-1.51l-1.63.68A4.05 4.05 0 0 0 87.29 44c2.19 0 4-1.29 4-4.43V32h-1.72zm-2.14 5.88a2.59 2.59 0 0 1 0-5.16A2.4 2.4 0 0 1 89.7 36a2.38 2.38 0 0 1-2.28 2.58zm24.38-11.08h-4.47V40h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76zm0 6h-2.61v-4.26h2.65a2.14 2.14 0 1 1 0 4.29zm11.53-1.8a3.5 3.5 0 0 0-3.33 1.91l1.66.69a1.77 1.77 0 0 1 1.7-.92 1.8 1.8 0 0 1 2 1.61v.13a4.13 4.13 0 0 0-1.95-.48c-1.79 0-3.6 1-3.6 2.81a2.89 2.89 0 0 0 3.1 2.75 2.63 2.63 0 0 0 2.4-1.2h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.33 2-1.33a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.19 2zM133.74 32l-2.14 5.42h-.06L129.32 32h-2l3.33 7.58-1.9 4.21h1.95L135.82 32zm-16.81 8h1.87V27.5h-1.87z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.44 17.54a2 2 0 0 0-.46 1.4v22.12a2 2 0 0 0 .46 1.4l.07.07L32.9 30.15v-.29L20.51 17.47z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.28l-4.1-4.13v-.29l4.1-4.14.09.05L42 28.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78z",
    fill: "url(#b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.12 34.22L32.9 30 20.44 42.46a1.63 1.63 0 0 0 2.08.06l14.61-8.3",
    fill: "url(#c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.12 25.78l-14.61-8.3a1.63 1.63 0 0 0-2.08.06L32.9 30z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37 34.13l-14.49 8.25a1.67 1.67 0 0 1-2 0l-.07.07.07.07a1.66 1.66 0 0 0 2 0l14.61-8.3z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44 42.32a2 2 0 0 1-.46-1.4v.15a2 2 0 0 0 .46 1.4l.07-.07zM42 31.3l-5 2.83.09.09L42 31.44A1.75 1.75 0 0 0 43 30a1.86 1.86 0 0 1-1 1.3z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.51 17.62L42 28.7a1.86 1.86 0 0 1 1 1.3 1.75 1.75 0 0 0-1-1.44L22.51 17.48c-1.4-.79-2.54-.13-2.54 1.47v.15c.03-1.61 1.15-2.27 2.54-1.48z",
    style: {
      isolation: "isolate"
    },
    fill: "#fff",
    opacity: 0.25
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.28 23v-6h1.84a3 3 0 0 1 2.21.83 2.94 2.94 0 0 1 .83 2.17 2.94 2.94 0 0 1-.83 2.17 3 3 0 0 1-2.21.83zm.77-.74h1.06a2.25 2.25 0 0 0 1.65-.6 2.23 2.23 0 0 0 .61-1.66 2.09 2.09 0 0 0-2.25-2.26H52zM57.24 23v-6H58v6zM61.07 23.13a2.24 2.24 0 0 1-1.28-.43 2 2 0 0 1-.82-1.2l.7-.28a1.61 1.61 0 0 0 .51.83 1.3 1.3 0 0 0 .88.34 1.4 1.4 0 0 0 .86-.26.84.84 0 0 0 .36-.72.92.92 0 0 0-.36-.77 3.69 3.69 0 0 0-1.13-.51 3 3 0 0 1-1.21-.65 1.36 1.36 0 0 1-.41-1 1.49 1.49 0 0 1 .51-1.12 1.87 1.87 0 0 1 1.32-.49 1.93 1.93 0 0 1 1.24.38 1.76 1.76 0 0 1 .62.83l-.7.29a1 1 0 0 0-.37-.53 1.31 1.31 0 0 0-1.53 0 .75.75 0 0 0-.31.62.7.7 0 0 0 .29.57 2.78 2.78 0 0 0 .85.41 7.23 7.23 0 0 1 .74.28 3.38 3.38 0 0 1 .6.36 1.42 1.42 0 0 1 .46.55 1.79 1.79 0 0 1 .16.77 1.65 1.65 0 0 1-.18.78 1.46 1.46 0 0 1-.48.54 2.37 2.37 0 0 1-.64.31 2.4 2.4 0 0 1-.68.1zM65 23h-.77v-6h2a1.9 1.9 0 0 1 1.32.51 1.74 1.74 0 0 1 0 2.56 1.89 1.89 0 0 1-1.32.51H65zm0-3.17h1.29a1 1 0 0 0 .78-.33 1 1 0 0 0 0-1.44 1 1 0 0 0-.78-.33H65zM74 22.22a3.12 3.12 0 0 1-4.4 0 3.24 3.24 0 0 1 0-4.45 3.1 3.1 0 0 1 4.4 0 3.23 3.23 0 0 1 0 4.45zm-3.83-.5a2.31 2.31 0 0 0 3.26 0 2.56 2.56 0 0 0 0-3.44 2.31 2.31 0 0 0-3.26 0 2.56 2.56 0 0 0 0 3.44zM75.95 23v-6h.94l2.92 4.67V17h.77v6h-.8l-3.05-4.89V23zM81.95 23v-6h.77v6zM84.09 23v-6h2.17a1.76 1.76 0 0 1 1.22.46 1.51 1.51 0 0 1 .52 1.17 1.31 1.31 0 0 1-.22.75 1.39 1.39 0 0 1-.59.49 1.52 1.52 0 0 1 .73.52 1.36 1.36 0 0 1 .29.86 1.57 1.57 0 0 1-.54 1.22 1.85 1.85 0 0 1-1.28.49zm.77-3.43h1.4a.9.9 0 0 0 .7-.29A.89.89 0 0 0 87 18a.86.86 0 0 0-.67-.29h-1.47zm0 2.69h1.55a.92.92 0 0 0 .72-.31 1 1 0 0 0 .28-.68 1 1 0 0 0-1-1h-1.55zM89.24 23v-6H90v5.26h2.6V23zM97.08 17.74h-2.73v1.9h2.46v.72h-2.46v1.9h2.73V23h-3.5v-6h3.5zM101.74 23.13a2.24 2.24 0 0 1-1.28-.43 2 2 0 0 1-.82-1.2l.7-.28a1.61 1.61 0 0 0 .51.83 1.3 1.3 0 0 0 .88.34 1.4 1.4 0 0 0 .86-.26.84.84 0 0 0 .36-.72.92.92 0 0 0-.36-.77 3.69 3.69 0 0 0-1.13-.51 3 3 0 0 1-1.21-.65 1.36 1.36 0 0 1-.41-1 1.49 1.49 0 0 1 .51-1.12 1.87 1.87 0 0 1 1.33-.48 1.93 1.93 0 0 1 1.24.38 1.76 1.76 0 0 1 .62.83l-.7.29a1 1 0 0 0-.37-.53 1.31 1.31 0 0 0-1.53 0 .75.75 0 0 0-.31.62.7.7 0 0 0 .29.57 2.78 2.78 0 0 0 .85.41 7.24 7.24 0 0 1 .74.28 3.38 3.38 0 0 1 .6.36 1.42 1.42 0 0 1 .46.55 1.79 1.79 0 0 1 .16.77 1.65 1.65 0 0 1-.18.78 1.46 1.46 0 0 1-.48.54 2.37 2.37 0 0 1-.64.31 2.4 2.4 0 0 1-.69.09zM106.94 23.13a2.11 2.11 0 0 1-1.61-.65 2.39 2.39 0 0 1-.62-1.71V17h.77v3.8a1.72 1.72 0 0 0 .37 1.15A1.54 1.54 0 0 0 108 22a1.72 1.72 0 0 0 .37-1.15V17h.77v3.77a2.43 2.43 0 0 1-.6 1.71 2.1 2.1 0 0 1-1.6.65zM110.4 23v-6h2a1.9 1.9 0 0 1 1.32.51 1.73 1.73 0 0 1 .15 2.39 1.78 1.78 0 0 1-1 .61l1.68 2.49h-.91L112 20.57h-.86V23zm.77-3.15h1.24a1.13 1.13 0 0 0 .79-.3 1 1 0 0 0 .33-.76 1.06 1.06 0 0 0-.29-.72 1 1 0 0 0-.78-.33h-1.29z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreDownload);
export default __webpack_public_path__ + "static/media/playstore-download.f23f5a3c.svg";
export { ForwardRef as ReactComponent };